import { render, staticRenderFns } from "./ProductPopup.vue?vue&type=template&id=3873401a"
import script from "./ProductPopup.vue?vue&type=script&lang=js"
export * from "./ProductPopup.vue?vue&type=script&lang=js"
import style0 from "./ProductPopup.vue?vue&type=style&index=0&id=3873401a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports